var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"dashboard-no-data",style:({height: _vm.height+'px'})},[_vm._v(" "+_vm._s(_vm.$t('label_dashboard_no_data'))+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }